import Name from './Name';
import Type from './Type';
import Search from './Search';
import SearchInput from './SearchInput';
import Select from './Select';
import RemoteSelect from './RemoteSelect';

export default {
    Name,
    Type,
    Search,
    Select,
    RemoteSelect,
    SearchInput
}